const ru: Record<string, string> = {
  'auth.title': 'Вход',
  'auth.subtitle': 'Мы отправим одноразовый код на вашу почту.',
  'auth.email': 'Электронная почта',
  'auth.sendCode': 'Получить код',
  'auth.needsNetwork': 'Для входа нужна сеть.',
  'auth.changeEmail': 'Другой адрес',
  'auth.codeTitle': 'Введите код',
  'auth.codeSent': 'Если адрес {email} есть в списке доступа, на него придёт 6-значный код. Он действует 5 минут.',
  'auth.code': 'Код из письма',
  'auth.verify': 'Войти',
  'auth.resend': 'Отправить код ещё раз',
  'auth.resendIn': 'Повторная отправка через {s} с',
  'auth.privateNote': 'Greek Notebook — закрытое приложение. Доступ только по приглашению.',
  'auth.signOutUnsyncedTitle': 'Есть несинхронизированные черновики',
  'auth.signOutUnsyncedText': 'На устройстве {n} стр. ещё не отправлены на сервер. При выходе локальные данные удаляются, и эти страницы будут потеряны. Лучше дождаться синхронизации.',
  'auth.sessionExpired': 'Сессия завершена — войдите снова.',
};
const en: Record<string, string> = {
  'auth.title': 'Sign in',
  'auth.subtitle': 'We will email you a one-time code.',
  'auth.email': 'Email',
  'auth.sendCode': 'Send code',
  'auth.needsNetwork': 'Signing in requires a network connection.',
  'auth.changeEmail': 'Different address',
  'auth.codeTitle': 'Enter the code',
  'auth.codeSent': 'If {email} is on the access list, a 6-digit code is on its way. It is valid for 5 minutes.',
  'auth.code': 'Code from the email',
  'auth.verify': 'Sign in',
  'auth.resend': 'Resend code',
  'auth.resendIn': 'Resend available in {s} s',
  'auth.privateNote': 'Greek Notebook is a private app. Access is by invitation only.',
  'auth.signOutUnsyncedTitle': 'Unsynced drafts on this device',
  'auth.signOutUnsyncedText': '{n} page(s) have not reached the server yet. Signing out deletes local data and these pages would be lost. Better wait for sync.',
  'auth.sessionExpired': 'Your session ended — sign in again.',
};
export default { ru, en };
